/*! dependencies: cash */
instant.popstate = {
  status: {
    hasInitPopState: false
  },
  init: function () {
    instant.popstate.initPopstate();
  },
  initPopstate: function () {
    if (!instant.popstate.status.hasInitPopState) {
      instant.popstate.bindEvents();
      instant.popstate.status.hasInitPopState = true;

    }

  },
  bindEvents: function () {
    window.addEventListener('popstate', function () {
      var page = window.getURLParam('page');

      if (instant.filteredList) {
        cash('.filtered-list-wrapper').each(function () {
          var wrapper = cash(this);

          instant.filteredList.updateFilters(wrapper);
          instant.filteredList.loadMore(wrapper, false, page);
        });
      }

      if (instant.pagination) {

        cash('.paging-wrapper').each(function () {
          var wrapper = cash(this);

          if (wrapper.closest('.filtered-list-wrapper').length == 0) {
            instant.pagination.loadMore(wrapper, page, false);
          }
        });
      }
    });
  }
};